// hd-redesign-p1 — the welcome-offer popup.
//
// Once per visitor, 5000ms after load, keyed on localStorage 'hd_popup_p1'.
// The key is written when the popup OPENS, not when it is dismissed, so a
// visitor who navigates away mid-timer is not shown it again on the next page.
//
// localStorage is read and written inside try/catch because Safari private mode
// and in-app browsers THROW on access rather than returning null — the house
// rule already stated at snippets/hd-offer-toast.liquid:155. It fails OPEN
// (popup shown), which is the harmless direction.
//
// ── THE FORM ────────────────────────────────────────────────────────────────
// The markup is a real {% form 'customer' %}, so with JS off it posts natively,
// Shopify redirects back, and Liquid re-renders the popup already open in its
// success state. With JS on, submit is intercepted and POSTed with fetch so the
// success state appears inline and the page does not reload — which is the
// export's behaviour.
//
// A cross-form caveat that used to apply here does NOT any more: Shopify
// reports form.posted_successfully? to EVERY customer form on the page
// (sections/hd-email-capture.liquid:26-32). This branch removes the footer
// newsletter and the homepage email band, so the popup is the only customer
// form rendered, and the server-side success state cannot be triggered by
// someone else's submit.
(function () {
  "use strict";

  var KEY = "hd_popup_p1";
  var DELAY = 5000;

  function init() {
    var popup = document.querySelector("[data-hd-popup]");
    if (!popup) return;

    var card = popup.querySelector("[data-hd-popup-card]");
    var form = popup.querySelector("[data-hd-popup-form]");
    var fields = popup.querySelector("[data-hd-popup-fields]");
    var input = popup.querySelector("[data-hd-popup-email]");
    var done = popup.querySelector("[data-hd-popup-done]");
    var closeBtn = popup.querySelector("[data-hd-popup-close]");
    var lastFocus = null;

    function read() {
      try {
        return !!window.localStorage.getItem(KEY);
      } catch (e) {
        return false;
      }
    }

    function mark() {
      try {
        window.localStorage.setItem(KEY, "1");
      } catch (e) {
        /* storage refused; the popup simply shows again next visit */
      }
    }

    function open() {
      if (!popup.hidden) return;
      lastFocus = document.activeElement;
      popup.hidden = false;
      document.documentElement.style.overflow = "hidden";
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      if (popup.hidden) return;
      popup.hidden = true;
      document.documentElement.style.overflow = "";
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    // The <form> element itself is never hidden — only the field group inside
    // it. Hiding the form would take the server-rendered success message down
    // with it, since Liquid renders both states inside the same {% form %}.
    function succeed() {
      if (done) done.hidden = false;
      if (fields) fields.hidden = true;
    }

    // Server-rendered success. Liquid emits this marker only when Shopify
    // redirected back from a native (JS-off) post, and it has already rendered
    // the success state; all this has to do is bring the popup up so the
    // confirmation is actually seen.
    if (popup.querySelector("[data-hd-popup-posted]")) {
      open();
    } else if (!read()) {
      window.setTimeout(function () {
        mark();
        open();
      }, DELAY);
    }

    document.addEventListener("click", function (e) {
      var opener = e.target.closest ? e.target.closest("[data-hd-popup-open]") : null;
      if (opener) {
        e.preventDefault();
        open();
      }
    });

    if (closeBtn) closeBtn.addEventListener("click", close);

    // Backdrop only — a click that started inside the card must not close it.
    popup.addEventListener("mousedown", function (e) {
      if (card && !card.contains(e.target)) close();
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") close();
    });

    // A minimal focus loop. The popup is aria-modal, so anything reachable
    // behind it would be a lie to a screen reader that honours the attribute.
    popup.addEventListener("keydown", function (e) {
      if (e.key !== "Tab" || !card) return;
      var f = card.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
      if (!f.length) return;
      var first = f[0];
      var last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });

    if (form && input) {
      form.addEventListener("submit", function (e) {
        var v = input.value.trim();
        if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v)) {
          // Let the browser's own required/type=email messaging handle the
          // wording; this only marks the field and stops the round trip.
          input.setAttribute("aria-invalid", "true");
          return;
        }
        input.removeAttribute("aria-invalid");

        if (!window.fetch) return; // native post, page reloads, Liquid succeeds

        e.preventDefault();
        fetch(form.action, {
          method: "POST",
          body: new FormData(form),
          headers: { Accept: "text/html" }
        })
          .then(function (r) {
            if (r.ok) succeed();
            else form.submit();
          })
          .catch(function () {
            form.submit();
          });
      });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", init);
})();
